import { useNavigate } from 'react-router';
import { Card } from '@/components/ui/card';
import { MediaThumbnail } from '../MediaThumbnail';
import { EventIcon } from '../EventIcon';
import { formatElapsedTime } from '@/utils/formatElapsedTime';
import type { Event } from '@/types/api/events';

interface EventCardProps {
  event: Event;
  clientName?: string;
}

export function EventCard({ event, clientName }: EventCardProps) {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/property/${event.client_id}`);
  };

  return (
    <Card
      className="cursor-pointer overflow-hidden"
      onDoubleClick={handleClick}
    >
      <div className="flex">
        <MediaThumbnail eventId={event.event_id} eventType={event.event_type} />

        {/* Content */}
        <div className="flex-1 ps-3 min-w-0">
          <div className="flex items-center justify-between gap-2">
            {/* Left content */}
            <div className="flex-1 min-w-0">
              {/* Event icon and action */}
              <div className="flex items-center gap-2 mb-1">
                <EventIcon eventType={event.event_type} />
                <span className="text-sm font-medium text-gray-900 capitalize">
                  {event.event_type.replace(/_/g, ' ')}
                </span>
              </div>
              {/* Description */}
              {/* <div className="text-sm text-gray-600 truncate">
                {event.description}
              </div> */}
            </div>

            {/* Right content - timestamp */}
            <div className="flex flex-col flex-1 min-w-0 gap-1">
              <p className="text-gray-400 text-sm italic w-full text-right">
                {event.event_id}
              </p>
              <div className="flex flex-row">
                <div className="text-xs text-gray-600 truncate flex-auto">
                  {clientName || `Client: ${event.client_id}`}
                </div>
                <div className="text-xs text-gray-500 whitespace-nowrap flex-auto text-right">
                  {formatElapsedTime(event.creation_time)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
